// 📄 miEspacioSeguridadService.ts
// PIN personal opcional para bloquear "Mi Espacio" (ver
// MiEspacioPinGate.tsx) — el PIN NUNCA pasa por Firestore directo desde el
// navegador, solo vía onehubApi (/mi-espacio-seguridad), mismo patrón que
// clienteConexionService.ts para el código de confirmación de producción.
import { getAuth } from "firebase/auth";

const getToken = async (): Promise<string> => {
  const user = getAuth().currentUser;
  if (!user) throw new Error("No se detectó una sesión activa. Por favor, reingresa al sistema.");
  return user.getIdToken();
};

const post = async (path: string, body: object) => {
  const token = await getToken();
  const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(body)
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Error ${response.status} al comunicarse con el servidor.`);
  }
  return data;
};

export const obtenerEstadoPinMiEspacio = async (): Promise<{ tienePin: boolean }> => {
  return post("/mi-espacio-seguridad/estado", {});
};

export const guardarPinMiEspacio = async (pin: string): Promise<void> => {
  await post("/mi-espacio-seguridad/guardar", { pin });
};

export const verificarPinMiEspacio = async (pin: string): Promise<boolean> => {
  const { valido } = await post("/mi-espacio-seguridad/verificar", { pin });
  return valido;
};

export const eliminarPinMiEspacio = async (): Promise<void> => {
  await post("/mi-espacio-seguridad/eliminar", {});
};
